import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { translate } from '@ngneat/transloco';

@Component({
    selector: 'form-field-tooltip',
    templateUrl: 'form-field-tooltip.component.html',
    styleUrls: ['./form-field-tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class FormFieldTooltipComponent implements OnInit {
    @Input() tooltipTitleKey: string;
    @Input() tooltipKey: string;

    constructor(
        private _fuseConfirmationService: FuseConfirmationService,
    ) { }

    ngOnInit() { }

    onClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        let dialogRef = this._fuseConfirmationService.open({
            'title': translate(this.tooltipTitleKey),
            'message': translate(this.tooltipKey),
            'icon': {
                'show': true,
                'name': 'heroicons_outline:information-circle',
                'color': 'info'
            },
            'actions': {

                'confirm': {
                    'show': false,
                    'label': translate('save-button'),
                    'color': 'primary'
                },
                'cancel': {
                    'show': false,
                    'label': translate('close-button')
                }
            },
            'dismissible': true
        });
    }
}
